<template>
  <b-form-group :label-for="labelForAttr">
    <template v-if="label" #label>
      {{ label }}<span v-if="isRequired" class="text-danger"> *</span>
    </template>
    <validation-provider
      #default="{ errors }"
      :vid="vid || name"
      :name="name"
      :rules="validate"
      v-bind="validationProviderAttrs"
    >
      <input
        :id="id"
        :disabled="disabled"
        :type="type"
        :class="['form-control bg-white' , { 'is-invalid': errors.length > 0 }]"
        :value="value"
        :placeholder="placeholder"
        @input="$emit('input', $event.target.value)"
      >
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>
<script>
function isFieldRequired (validate) {
  if (!validate) return false
  if (typeof validate === 'object') {
    return validate.required === true || validate.required === ''
  }
  return String(validate).split('|').some(rule => {
    const name = rule.split(':')[0].trim()
    return name === 'required' || name === 'arabic_name' || name === 'english_name'
  })
}

export default {
  props: {
    label: {
      default: '',
      type: String
    },
    name: {
      default: '',
      type: String
    },
    type: {
      default: 'text'
    },
    id: {
      default: '',
      type: String
    },
    validate: {
      type: [String, Object],
      default: ''
    },
    value: {
      default: '',
      type: String
    },
    placeholder: {
      default: '',
      type: String
    },
    disabled: {
      default: false
    },
    customMessages: {
      type: Object,
      default: () => ({})
    },
    mode: {
      type: String,
      default: ''
    },
    vid: {
      type: String,
      default: ''
    }
  },
  computed: {
    isRequired () {
      return isFieldRequired(this.validate)
    },
    labelForAttr () {
      return this.id || this.name
    },
    validationProviderAttrs () {
      const attrs = {}
      if (this.mode) {
        attrs.mode = this.mode
      }
      if (this.customMessages && Object.keys(this.customMessages).length) {
        attrs.customMessages = this.customMessages
      }
      return attrs
    }
  },
  methods: {
    test (t, y) {
      console.log(t, y)
    }
  }
}
</script>
